import { client } from "../client/client";

export const getLoans = async (
  page,
  limit,
  fromDate,
  toDate,
  search,
  status,
  loanOfficerId,
  productName,
  minBalance,
  maxBalance,
) => {
  try {
    const params = new URLSearchParams();

    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (search) params.append("q", search);
    if (status) params.append("status", status);
    if (loanOfficerId) params.append("loanOfficerId", loanOfficerId);
    if (productName) params.append("productName", productName);
    if (minBalance) params.append("minBalance", minBalance);
    if (maxBalance) params.append("maxBalance", maxBalance);

    const response = await client.get(`/loans?${params.toString()}`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanStatistics = async (fromDate, toDate) => {
  try {
    const params = new URLSearchParams();
    if (fromDate) params.append("from", fromDate);
    if (toDate) params.append("to", toDate);

    const response = await client.get(
      `/loans/status-counts/all?${params.toString()}`,
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanSummaryReport = async (fromDate, toDate) => {
  try {
    const params = new URLSearchParams();
    if (fromDate) params.append("startDate", fromDate);
    if (toDate) params.append("endDate", toDate);

    const response = await client.get(
      `/report/loan-summary?${params.toString()}`,
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanById = async (loanId) => {
  try {
    const response = await client.get(`/loans/${loanId}`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanPenalties = async (loanId) => {
  try {
    const response = await client.get(`/loans/${loanId}/penalties`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanTotals = async () => {
  try {
    const response = await client.get(`/loans/summary/totals`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanTotalsByStatus = async () => {
  try {
    const response = await client.get(`/loans/summary/by-status`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanDistributionByProduct = async () => {
  try {
    const response = await client.get(`/loans/distribution/by-product`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanOfficerPerformance = async () => {
  try {
    const response = await client.get(`/loans/officer-performance`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoansByBorrowerId = async (borrowerId) => {
  try {
    const response = await client.get(
      `/loans/history?borrowerId=${borrowerId}`,
    );
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const disburseMyLoan = async (
  loanId,
  disbursedAmount,
  method,
  reference,
  phoneNumber,
  customerName,
  disburseDate,
) => {
  try {
    const payload = {
      loanId,
      disbursedAmount,
      method,
      reference,
      disbursedAt: disburseDate,
      recipientMsisdn: phoneNumber,
      recipientName: customerName,
      consentAlternateRecipient: true,
    };

    // Remove null, undefined, and empty values
    const sanitizedPayload = Object.fromEntries(
      Object.entries(payload).filter(
        ([, value]) => value !== null && value !== undefined && value !== "",
      ),
    );

    const response = await client.post(`/loan/disburse`, sanitizedPayload);

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const disburseByBank = async (
  loanId,
  disbursedAmount,
  method,
  reference,
  disbursedAt,
  bank,
  bankAccountNumber,
  receiptUrl,
) => {
  try {
    const response = await client.post(`/loan/disburse/bank`, {
      loanId,
      disbursedAmount,
      method,
      reference,
      disbursedAt,
      bank,
      bankAccountNumber,
      receiptUrl,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const declineMyDisbursement = async (
  loanId,
  reason,
  supportingDocumentUrl,
) => {
  try {
    const response = await client.post(`/loan/disbursements/decline`, {
      loanId,
      reason,
      supportingDocumentUrl,
    });
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getBorrowerGuaranteedLoans = async (borrowerId) => {
  try {
    const response = await client.get(
      `/guarantors/borrower-guaranteed-loans?borrowerId=${borrowerId}`,
    );
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
